export const setCssCustomProperty = {
  set: (key, value, el = document.documentElement) => {
    el.style.setProperty(key, value)
  }
}
